import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import { getMonthName } from "../General/Utility";

import { toast, ToastContainer } from "react-toastify";

const HeadwiseReceiveableFeePrintDetailed = () => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [studentList, setStudentList] = useState([]);
  const [feeTypes, setFeeTypes] = useState([]);
  const [Month, setMonth] = useState("");
  const [Year, setYear] = useState("");
  const [WingId, setWingId] = useState(0);
  const [FeetypeID, setFeetypeID] = useState(0);
  const [ClassId, setClassId] = useState(0);
  const [SectionID, setSectionID] = useState(0);
  const [IncludeArrears, setIncludeArrears] = useState(false);

  // pagination
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    document.title = "Headwise Receiveable Fee - Detailed Report";

    setLoading(true);
    // Get the URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Retrieve individual parameter values
    const month = urlParams.get("Month");
    const year = urlParams.get("Year");
    const wingId = urlParams.get("Wing_Id") || "0";
    const feetype = urlParams.get("FeeTypeId") || "0";
    const classId = urlParams.get("Class_Id") || "0";
    const sectionId = urlParams.get("Section_Id") || "0";
    const includeArrears = urlParams.get("IncludeArrears") || "0";

    setMonth(month);
    setYear(year);
    setWingId(parseInt(wingId));
    setFeetypeID(parseInt(feetype));
    setClassId(parseInt(classId));
    setSectionID(parseInt(sectionId));
    setIncludeArrears(includeArrears === "1");

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: 1,
      pageSize: 100000,
      ReportMonth: month,
      ReportYear: year,
      Wing_Id: parseInt(wingId),
      FeeTypeId: parseInt(feetype),
      Class_Id: parseInt(classId),
      Section_Id: parseInt(sectionId),
      IncludeArrears: includeArrears === "1",
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Reports/GetHeadwiseReceiveableFeeDetailed",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setStudentList(response.data.ListofRecords || []);
          setFeeTypes(response.data.FeeTypes || []);
          setLoading(false);
          setTotalRecords(response.data.totalRecords || 0);
        } else {
          setStudentList([]);
          setFeeTypes([]);
          setTotalRecords(0);
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setLoading(false);
        }
      })
      .catch(function (error) {
        setLoading(false);
        toast.error("Error loading data", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  }, []);

  const formatNumber = (num) => {
    if (!num || num === 0) return "";
    return num.toLocaleString("en-US");
  };

  const renderStudents = () => {
    if (studentList != null && studentList.length > 0) {
      let count = 1;
      return studentList.map((student, index) => {
        return (
          <tr key={index}>
            <td style={{ textAlign: "center", padding: "6px", border: "1px solid #000", fontSize: "9px" }}>
              {count++}
            </td>
            <td style={{ padding: "6px", border: "1px solid #000", fontSize: "9px" }}>
              {student.Student_Name || "-"}
            </td>
            <td style={{ padding: "6px", border: "1px solid #000", fontSize: "9px" }}>
              {student.Father_Name || "-"}
            </td>
            <td style={{ padding: "6px", border: "1px solid #000", fontSize: "9px" }}>
              {student.Registration_No || "-"}
            </td>
            <td style={{ padding: "6px", border: "1px solid #000", fontSize: "9px" }}>
              {student.Class || "-"}
            </td>
            {feeTypes.map((feeType) => {
              const balance = student[feeType.Fee_Type_Name] || 0;
              return (
                <td
                  key={feeType.Fee_Type_ID}
                  style={{
                    textAlign: "right",
                    padding: "6px",
                    border: "1px solid #000",
                    fontSize: "9px",
                  }}
                >
                  {formatNumber(balance)}
                </td>
              );
            })}
            <td
              style={{
                textAlign: "right",
                padding: "6px",
                border: "1px solid #000",
                fontSize: "9px",
                fontWeight: "bold",
              }}
            >
              {formatNumber(student.Balance || 0)}
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td
            colSpan={5 + feeTypes.length + 1}
            style={{ textAlign: "center", padding: "20px", border: "1px solid #000" }}
          >
            <h4 style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };

  // Trigger print when component loads
  useEffect(() => {
    if (!loading && studentList.length > 0) {
      setTimeout(() => {
        window.print();
      }, 500);
    }
  }, [loading, studentList]);

  return (
    <>
      <ToastContainer />
      <style>
        {`
          @media print {
            body {
              margin: 0;
              padding: 0;
            }
            .no-print {
              display: none !important;
            }
            @page {
              size: A4 landscape;
              margin: 10mm;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 10px;
            }
            th, td {
              border: 1px solid #000;
              padding: 6px;
              text-align: left;
            }
            th {
              background-color: #f0f0f0;
              font-weight: bold;
            }
          }
          @media screen {
            .print-container {
              padding: 20px;
            }
          }
        `}
      </style>
      <div className="print-container">
        <Page orientation="landscape" size="a4">
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "11px",
              fontFamily: "Arial, sans-serif",
            }}
          >
            <thead>
              <tr>
                <th
                  colSpan={5 + feeTypes.length + 1}
                  style={{ padding: "15px", border: "1px solid #000", textAlign: "center" }}
                >
                  <PrintHeader
                    title={`Headwise Receiveable Fee - Detailed Report For : ${getMonthName(
                      Month
                    )}, ${Year}${IncludeArrears ? " (With Arrears)" : ""}`}
                  />
                </th>
              </tr>
              <tr>
                <th
                  style={{
                    padding: "8px",
                    border: "1px solid #000",
                    backgroundColor: "#f0f0f0",
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "10px",
                  }}
                >
                  Sr.
                </th>
                <th
                  style={{
                    padding: "8px",
                    border: "1px solid #000",
                    backgroundColor: "#f0f0f0",
                    textAlign: "left",
                    fontWeight: "bold",
                    fontSize: "10px",
                  }}
                >
                  Student Name
                </th>
                <th
                  style={{
                    padding: "8px",
                    border: "1px solid #000",
                    backgroundColor: "#f0f0f0",
                    textAlign: "left",
                    fontWeight: "bold",
                    fontSize: "10px",
                  }}
                >
                  Father Name
                </th>
                <th
                  style={{
                    padding: "8px",
                    border: "1px solid #000",
                    backgroundColor: "#f0f0f0",
                    textAlign: "left",
                    fontWeight: "bold",
                    fontSize: "10px",
                  }}
                >
                  Adm.
                </th>
                <th
                  style={{
                    padding: "8px",
                    border: "1px solid #000",
                    backgroundColor: "#f0f0f0",
                    textAlign: "left",
                    fontWeight: "bold",
                    fontSize: "10px",
                  }}
                >
                  Class
                </th>
                {feeTypes.map((feeType) => (
                  <th
                    key={feeType.Fee_Type_ID}
                    style={{
                      padding: "8px",
                      border: "1px solid #000",
                      backgroundColor: "#f0f0f0",
                      textAlign: "right",
                      fontWeight: "bold",
                      fontSize: "10px",
                    }}
                  >
                    {feeType.Fee_Type_Name}
                  </th>
                ))}
                <th
                  style={{
                    padding: "8px",
                    border: "1px solid #000",
                    backgroundColor: "#f0f0f0",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "10px",
                  }}
                >
                  Balance
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td
                    className="text-center"
                    colSpan={5 + feeTypes.length + 1}
                    style={{ padding: "20px", border: "1px solid #000" }}
                  >
                    <Spinner animation="border" role="status"></Spinner>
                  </td>
                </tr>
              ) : (
                <>
                  {renderStudents()}
                  <tr>
                    <td
                      colSpan={5}
                      style={{
                        padding: "8px",
                        border: "1px solid #000",
                        textAlign: "right",
                        fontWeight: "bold",
                        backgroundColor: "#f0f0f0",
                        fontSize: "10px",
                      }}
                    >
                      Total ({totalRecords} Records):
                    </td>
                    {feeTypes.map((feeType) => {
                      const total = studentList.reduce(
                        (sum, student) => sum + (parseFloat(student[feeType.Fee_Type_Name]) || 0),
                        0
                      );
                      return (
                        <td
                          key={feeType.Fee_Type_ID}
                          style={{
                            padding: "8px",
                            border: "1px solid #000",
                            textAlign: "right",
                            fontWeight: "bold",
                            backgroundColor: "#f0f0f0",
                            fontSize: "10px",
                          }}
                        >
                          {formatNumber(total)}
                        </td>
                      );
                    })}
                    <td
                      style={{
                        padding: "8px",
                        border: "1px solid #000",
                        textAlign: "right",
                        fontWeight: "bold",
                        backgroundColor: "#f0f0f0",
                        fontSize: "10px",
                      }}
                    >
                      {formatNumber(
                        studentList.reduce((sum, student) => sum + (parseFloat(student.Balance) || 0), 0)
                      )}
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </Page>
      </div>
    </>
  );
};

export default HeadwiseReceiveableFeePrintDetailed;

